<template>
  <section class="default-container">
    <BreadCrumb :bread-crumb="breadCrumb" />
    <div class="content">
      <div class="content-left">
        <div class="left-title">월간인사관리</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]" @click="menuClick(index)">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div
                v-for="(subMenu, idx) in menu.subMenu"
                :key="'subMenu' + idx"
                :class="['sub-menu__item', {on: subMenu.selected}]"
                @click="subMenuClick(index, idx)"
              >
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="right-title">
          <div class="right-title__left">
            <kpi-book-icon />
            <div class="title">{{ magazine.title }}</div>
          </div>
          <div class="btn-wrap">
            <div v-if="magazine.hasPreviewFiles" class="is-14m preview-btn" @click="downFile('prec')">미리보기</div>
            <div class="is-14m down" @click="downFile('real')">다운로드</div>
          </div>
        </div>
        <img :src="magazine.imgPath" alt="월호 이미지" class="book-img" />
        <div v-for="(item, index) in magazine.subjectList" :key="'subject' + index" class="content-wrap">
          <div class="detail-subject">{{ item.title }}</div>
          <div v-for="(content, idx) in item.contents" :key="'content' + idx" class="right-content">
            <div class="content-title is-14b">{{ content.title }}</div>
            <div class="content-content" v-html="content.content" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {useMagazineStore} from '~/store/magazine/index.js'
import {useMemberStore} from '~/store/member/index.js'
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import KpiBookIcon from 'assets/svg/kpi-book-icon.vue'

export default {
  name: 'MagazineId',
  components: {KpiBookIcon, BreadCrumb},
  setup() {
    const store = useMagazineStore()
    const memberStore = useMemberStore()
    return {store, memberStore}
  },
  data() {
    return {
      isAuth: false,
      magazineId: null,
      menuList: [
        {
          name: '월간인사관리 안내',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '월간인사관리 안내', selected: false}]
        },
        {
          name: '목차',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '전체보기', selected: false},
            {name: 'Feature', selected: false},
            {name: 'Department', selected: false},
            {name: 'P&O', selected: false}
          ]
        },
        {
          name: '월호보기',
          selected: true,
          subMenuShow: true,
          subMenu: [{name: '월호보기', selected: true}]
        },
        {
          name: '구독 신청',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '구독 신청', selected: false}]
        },
        {
          name: '월간인사관리 광고문의',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '월간인사관리 광고문의', selected: false}]
        }
      ],
      breadCrumb: ['홈', '월간인사관리', '월호보기', '상세'],
      magazine: {
        downloadAvailable: false,
        id: 0,
        title: '',
        hasPreviewFiles: 1,
        imgPath: '',
        previewFilePath: '',
        attachedFiles: [],
        subjectList: [],
        yearMonth: ''
      }
    }
  },
  created() {
    this.magazineId = this.$route.params.magazineId
  },
  async mounted() {
    this.isAuth = this.memberStore.isAuthenticated
    await this.getMagazineMonthlyDetail()
  },
  methods: {
    async downFile(type) {
      if (type === 'real') {
        if (!this.isAuth) {
          alert('로그인 후 이용 가능합니다.')
        } else {
          // 다운로드 가능 체크
          const {data} = await this.store.getMagazineMonthlyDownload(this.magazineId)
          this.magazine.downloadAvailable = data.downloadAvailable
          this.magazine.attachedFiles = data.attachedFiles
          if (this.magazine.downloadAvailable) {
            this.magazine.attachedFiles.forEach(file => {
              window.open(file.url, '_blank')
            })
          } else {
            alert('구독 후 이용 가능합니다.')
            this.$router.push('/magazine?menu=3&subMenu=0')
          }
        }
      } else {
        window.open(this.magazine.previewFilePath, '_blank')
      }
    },
    menuClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/magazine?menu=0&subMenu=0')
          break
        case 1:
          this.$router.push('/magazine?menu=1&subMenu=0')
          break
        case 2:
          this.$router.push('/magazine?menu=2&subMenu=0')
          break
        case 3:
          this.$router.push('/magazine?menu=3&subMenu=0')
          break
        case 4:
          this.$router.push('/magazine?menu=4&subMenu=0')
          break
      }

      window.scrollTo({top: 0})
    },
    subMenuClick(index, idx) {
      this.$router.push(`/magazine?menu=${index}&subMenu=${idx}`)

      window.scrollTo({top: 0})
    },
    async getMagazineMonthlyDetail() {
      try {
        const {data} = await this.store.getMagazineMonthlyDetail(this.magazineId)
        this.magazine = data
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail-subject {
  padding: 12px 0px;
  border-bottom: 2px solid #0058aa;
  color: #0058aa;
  font-family: 'Godo', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
}

.default-container {
  padding: 48px 0 100px;

  .content {
    display: flex;
    gap: 24px;
    position: relative;

    .content-left {
      min-width: 222px;
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;

      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }

      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;

        &:hover {
          color: #0058aa;
        }

        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }

      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }

        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }

        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }

    .content-right {
      width: 100%;

      .right-title {
        border-top: 1px solid #dbdbdb;
        border-bottom: 1px solid #dbdbdb;
        background: #f8fbfd;
        padding: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        .right-title__left {
          display: flex;
          align-items: center;
          gap: 8px;

          .title {
            color: #0058aa;
            font-family: 'Godo', sans-serif;
            font-size: 18px;
            font-weight: 700;
          }
        }

        .btn-wrap {
          display: flex;
          gap: 8px;

          .is-14m {
            display: flex;
            padding: 7px 12px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: 4px;
            border: 1px solid #dbdbdb;
            background: #f2f2f2;
            cursor: pointer;

            &.down {
              background: #0058aa;
              color: #fff;
              border: 1px solid #0058aa;
            }
          }

          .preview-btn {
            padding: 7px 12px;
            border-radius: 4px;
            border: 1px solid #dbdbdb;
            background: #fff;
            cursor: pointer;
            color: #0058aa;
          }
        }
      }

      .book-img {
        width: 444px;
        height: 580px;
        margin-bottom: 24px;
      }

      .content-wrap {
        .right-content {
          margin-bottom: 24px;
          padding-bottom: 24px;
          border-bottom: 1px solid #dbdbdb;
        }

        .content-title {
          color: #f7967c;
          font-family: 'Godo', sans-serif;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 125%; /* 22.5px */
          margin-bottom: 12px;
        }

        .content-content {
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          white-space: pre-line;
        }
      }
    }
  }
}
</style>
